import React from "react";

import { ReferenciaOrganismos } from "../../../interfaces/ReferenciaOrganismos";
import CtaRichtextDescription from "../../atoms/cta-richtext-description/ctaRichtextDescription";
import Readtime from "../../atoms/readTime/readTime";
import RichtextDescription from "../../atoms/richtext-description/richtextDescription";
import ArticleExcerpt from "../../molecules/ArticleExcerpt/ArticleExcerpt";
import ArticleFeatureText from "../../molecules/ArticleFeatureText/ArticleFeatureText";
import ArticleParagraph from "../../molecules/ArticleParagraph/ArticleParagraph";
import FeaturedCards from "../../molecules/featured-cards/featuredCards";
import FeaturedEdition from "../../molecules/featured-edition/featuredEdition";
import FeaturedVideo from "../../molecules/fetured-video/featuredVideo";
import PaperEdition from "../../molecules/paper-edition/paperEdition";
import Question from "../../molecules/Question/Question";
import Quote from "../../molecules/quote/quote";
import RecentEditionsHome from "../../molecules/recent-editions-home/recentEditionsHome";
import SolutionsList from "../../molecules/SolutionsList/SolutionsList";
import Carousel from "../../organisms/carousel/carousel";
import UsersGallery from "../../organisms/users-gallery/UsersGallery";
import Gallery from "../../organisms/gallery/gallery";
import Podcasts from "../../organisms/podcasts/podcasts";
import OtherEditions from "../../organisms/otherEditions/otherEditions";
import Recognition from "../../molecules/recognition/recognition";
import History from "../../organisms/history/history";
import Etiquetas from "../../atoms/etiquetas/etiquetas";

import { adapterComponent } from "./adapters";
import QsRichtextDescription from "../../atoms/qs-richtext-description/qsRichtextDescription";

interface LibraryInterface {
  content: ReferenciaOrganismos;
  categoryName: string;
}

const LibraryComponents = (props: LibraryInterface) => {
  const refContent = props.content;
  const categoryName = props.categoryName;
  const componentName = props.content.tipoComponente;

  const componentsList = {
    UsersGallery,
    FeaturedCards,
    FeaturedVideo,
    FeaturedEdition,
    RecentEditionsHome,
    PaperEdition,
    ArticleExcerpt,
    ArticleFeatureText,
    ArticleParagraph,
    SolutionsList,
    Question,
    Recognition,
    ImagesSlideshow: Gallery,
    PodcastCarousel: Podcasts,
    EditionsGallery: OtherEditions,
    Quote,
    Etiquetas,
    // Suscribe,
    // Readtime,
    // Carousel
  };

  // if (!componentsList[componentName]) return <></>;
  // return componentsList[componentName](
  //   adapterComponent({
  //     component: componentName,
  //     data: refContent,
  //   })
  // );

  if (componentsList[componentName]) {
    return componentsList[componentName](
      adapterComponent({
        component: componentName,
        data: refContent,
      })
    );
  }

  switch (componentName) {
    case "BannerPrincipal":
      return <Carousel {...refContent} nombreCategoria={categoryName} />;

    case "RichText":
      return <RichtextDescription {...refContent} />;

    case "CtaRichText":
      return <CtaRichtextDescription {...refContent} />;

    case "QsRichText":
      return <QsRichtextDescription {...refContent} />;

    case "LineaDeTiempo":
      return <History {...refContent} />;
  }

  return <></>;
};

export default LibraryComponents;
